var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C15.3137 12 18 9.31371 18 6C18 2.68629 15.3137 0 12 0C8.68629 0 6 2.68629 6 6C6 9.31371 8.68629 12 12 12Z",
    fill: "#7161ba"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.999C7.03172 14.0046 3.00553 18.0307 3 22.999C3 23.5513 3.4477 23.999 3.99998 23.999H20C20.5522 23.999 21 23.5513 21 22.999C20.9945 18.0307 16.9683 14.0045 12 13.999Z",
    fill: "#7161ba"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAct);
export default __webpack_public_path__ + "static/media/userAct.4c36b1675b46de1f9ef814e942000315.svg";
export { ForwardRef as ReactComponent };